import {call, put, takeLatest} from 'redux-saga/effects';
import {
  getNotificationsRequest,
  getNotificationsSuccess,
  getNotificationsFailure,
  markAllAsReadRequest,
  markAllAsReadSuccess,
  markAllAsReadFailure,
} from '../slices/notificationSlice';

import {getNotifications, markAllNotificationsAsRead} from '@/services/api';
import {SUCCESS_KEY} from '@/constants/keys';

function* getNotificationsSaga(action: any): Generator {
  try {
    const response: any = yield call(getNotifications, action.payload);
    if (response.data.status === SUCCESS_KEY) {
      yield put(getNotificationsSuccess(response.data));
    } else {
      yield put(getNotificationsFailure(response.data));
    }
  } catch (error: any) {
    yield put(getNotificationsFailure(error.response?.data || {status: 'error', status_code: 'E-10001'}));
  }
}

function* markAllAsReadSaga(action: any): Generator {
  try {
    const response: any = yield call(markAllNotificationsAsRead, action.payload);
    if (response.data.status === SUCCESS_KEY) {
      yield put(markAllAsReadSuccess({response: response.data, id: action.payload?.id}));
    } else {
      yield put(markAllAsReadFailure(response.data));
    }
  } catch (error: any) {
    yield put(markAllAsReadFailure(error.response?.data || {status: 'error', status_code: 'E-10001'}));
  }
}

export default function* notificationSaga(): Generator {
  yield takeLatest(getNotificationsRequest.type, getNotificationsSaga);
  yield takeLatest(markAllAsReadRequest.type, markAllAsReadSaga);
}

